import { styled } from 'goober';

export const LayoutCard = styled('div')<{ isCenter?: boolean }>`
    position: relative;
    display: grid;
    margin-bottom: 16px;
    gap: 20px;
    padding: 0 0 20px;
    align-items: stretch;
    align-content: start;
    ${({ isCenter }) => {
        return isCenter
            ? `
                grid-template-columns: 1fr;      
              `
            : `
                grid-template-columns: repeat(3, 1fr);
              `;
    }}
`;
